import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = ({ openAuthModal, showToast, searchQuery, setSearchQuery }) => {
  const { user, logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [localSearch, setLocalSearch] = useState(searchQuery || '');
  const navigate = useNavigate();

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchQuery(localSearch);
    navigate('/');
  };

  const handleSearchChange = (e) => {
    setLocalSearch(e.target.value);
    // Debounced search - update after typing stops
    if (e.target.value === '') {
      setSearchQuery('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setSearchQuery(localSearch);
      navigate('/');
    }
  };

  const handleLogout = () => {
    logout();
    showToast('Logged out successfully');
    setDropdownOpen(false);
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    const names = name.split(' ');
    if (names.length >= 2) {
      return names[0][0] + names[1][0];
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <nav className="nav">
      <div className="nav-container">
        <div className="nav-left">
          <Link to="/" className="logo">
            <img 
              src="/logo.png" 
              alt="Synth" 
              style={{ height: '80px', width: 'auto', objectFit: 'contain' }}
              onError={(e) => {
                console.error('Logo image not found at /logo.png');
                e.target.style.display = 'none';
              }}
            />
          </Link>
          <div className="nav-links">
            <Link to="/" className="nav-link active">Feed</Link>
            <button className="nav-link">Explore</button>
            <button className="nav-link">Projects</button>
            <button className="nav-link">Integrations</button>
          </div>
        </div>
        <div className="nav-right">
          <form className="nav-search" onSubmit={handleSearchSubmit}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input 
              type="text" 
              placeholder="Search threads, projects, users..." 
              value={localSearch}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
            />
            {localSearch && (
              <button 
                type="button"
                onClick={() => { setLocalSearch(''); setSearchQuery(''); }}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--text-tertiary)',
                  padding: '4px'
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            )}
          </form>
          {user ? (
            <div className="user-menu">
              <button 
                className="user-avatar-btn"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                {getInitials(user.username)}
              </button>
              <div className={`user-dropdown ${dropdownOpen ? 'active' : ''}`}>
                <button 
                  className="user-dropdown-item"
                  onClick={() => {
                    navigate(`/profile/${user.username}`);
                    setDropdownOpen(false);
                  }}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  Profile
                </button>
                <button className="user-dropdown-item" onClick={handleLogout}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  Log out
                </button>
              </div>
            </div>
          ) : (
            <>
              <button className="btn btn-ghost" onClick={() => openAuthModal('signin')}>Sign In</button>
              <button className="btn btn-primary" onClick={() => openAuthModal('signup')}>Get Started</button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

